import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { UserSelectionType } from 'webapp/enums/enums';

import FormEmailRecipientsComponent from 'webapp/components/form/email-recipients';
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

interface Model {
	recipients: string[];
}

interface Args {
	model: Model;
	submitInProgress: boolean;
	onContentChange: () => void;
	excludeUserId?: number | null;
}

export default class GoalNotificationsRecipientsEmailsSelectorComponent extends Component<Args> {
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	// reusing UserSelectionType for OWNER & OWNER_AND_SELECTED
	@tracked recipientsType: UserSelectionType;

	recipientsTypeOptions = [
		{ value: UserSelectionType.ME, label: 'Only owner' },
		{
			value: UserSelectionType.ME_AND_SELECTED,
			label: 'Owner and selected users',
		},
	];

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		const recipientCount = this.model.recipients.length;

		this.recipientsType =
			recipientCount > 0 ? UserSelectionType.ME_AND_SELECTED : UserSelectionType.ME;
	}

	get model() {
		return this.args.model;
	}

	get showRecipients() {
		return this.recipientsType === UserSelectionType.ME_AND_SELECTED;
	}

	@action
	onRecipientsTypeChange(value: AnySimpleValue) {
		const selected = value as UserSelectionType;
		if (selected === UserSelectionType.ME) {
			this.model.recipients = [];
		}
		this.recipientsType = selected;
	}
	<template>
		<div class="recipients-emails-selector">
			<FormRadiobuttonGroupComponent
				class="radiobutton-default"
				@name="recipientsType"
				@selected={{this.recipientsType}}
				@options={{this.recipientsTypeOptions}}
				@isDisabled={{@submitInProgress}}
				@onChange={{this.onRecipientsTypeChange}}
			/>

			{{#if this.showRecipients}}
				<FormEmailRecipientsComponent
					@model={{this.model}}
					@excludeUserId={{@excludeUserId}}
					@submitInProgress={{@submitInProgress}}
					@onContentChange={{@onContentChange}}
					@showAvatar={{true}}
				/>
			{{/if}}
		</div>
	</template>
}
